'use client';

import { StaticBanner } from './StaticBanner';

interface BannerProps {
  policyBannerTypeList?: string[];
  idx: string;
}

export const Banner = ({ policyBannerTypeList, idx }: BannerProps) => {
  if (policyBannerTypeList?.length) {
    return null;
  }

  switch (idx) {
    case '3150f149-2eb2-43d7-8ec4-165ac135a087':
      return (
        <StaticBanner
          bannerList={['K 패스']}
          className="mb-28 px-24 mobile-tablet:px-16"
        />
      );

    default:
      return null;
  }
};
